// Get the pixel value per millimeter
export function getOneMmsPx () {
    let div = document.createElement("div");
    div.style.width = "1mm";
    document.querySelector("body").appendChild(div);
    let mm1 = div.getBoundingClientRect();
    let w = mm1.width;
    $(div).remove();
    return mm1.width;
}

/**
 * 获取纸张大小(mm)
 * @param {*} type 纸张类型
 * @param {*} direction 方向
 * @param {*} margins 页边距
 * @returns 
 */
export function getPaperSize (type, direction, margins = {}) {
    const mspx = 4.001;
    const paper = {
        'B5': {
            w: 130,
            h: 185
        },
        'A5': {
            w: 148,
            h: 210
        },
        'A4': {
            w: 210,
            h: 297
        },
        'A3': {
            w: 297,
            h: 420
        },
        'A2': {
            w: 420,
            h: 597
        },
    };

    let obj = {
        attr: paper[type],
        mspx,
        width: 0,
        height: 0,
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
    };
    //横向
    if (direction == 1) {
        obj.width = paper[type].h * mspx
        obj.height = paper[type].w * 3.61
    } else {
        obj.width = paper[type].w * mspx
        obj.height = paper[type].h  * 3.61
    }

    const { left, top, right, bottom } = margins;
    if (left) {
        obj.left = left * mspx;
        obj.width = obj.width - obj.left;
    };
    if (right) {
        obj.right = right * mspx;
        obj.width = obj.width - obj.right;
    }
    if (top) {
        obj.top = top * 3.61;
        obj.height = obj.height - obj.top;
    }

    if (bottom) {
        obj.bottom = bottom * 3.61;
        obj.height = obj.height - obj.bottom;
    }
    return obj
}